<template>
<div class="success" name="success">
  <topNav :title="title"></topNav>
  <div class="payContent">
      <div class="add_info">

          <div class="cus_section">
              <div class="cus_cell" >
                <i class="cus_icon icon_type"></i>
                <div class="cell_right">
                  <span>抬头类型：</span>
                  <div class="cus_radio_group">
                    <div @click="toggleCheck('radioType')" :class="['cus_radio_item', {'cus_checked': radioType === 1}]">
                      <i class="icon_radio"></i><span class="">企业单位</span>
                    </div>
                    <div @click="toggleCheck('radioType')" :class="['cus_radio_item', {'cus_checked': radioType === 0}]">
                      <i class="icon_radio"></i><span class="">个人/非企业单位</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cus_cell" >
                <i class="cus_icon icon_invoicetype"></i>
                <div class="cell_right">
                  <span>发票类型：</span>
                  <div class="cus_radio_group">
                    <div @click="toggleCheck('invoiceType')" :class="['cus_radio_item', {'cus_checked': invoiceType === 0}]">
                      <i class="icon_radio"></i><span class="">普票</span>
                    </div>
                    <div v-if="!isHZ"  @click="toggleCheck('invoiceType')" :class="['cus_radio_item', {'cus_checked': invoiceType === 1}]">
                      <i class="icon_radio"></i><span class="">专票</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cus_cell" >
                <i class="cus_icon icon_content"></i>
                <p class="cell_right"> <span>发票内容：{{ invoiceContent }}</span></p>
              </div>
              <div class="cus_cell">
                <i class="cus_icon icon_amount"></i>
                <p class="cell_right"><span> 发票金额： </span><span>{{ invoiceValue }}</span>元</p>
              </div>
          </div>
          <div class="cus_section">
            <div class="cus_cell">
              <i class="cus_icon icon_invoice"></i>
              <div class="cell_right"><input type="text" placeholder="请输入发票抬头" v-model="invoiceHead"></div>
            </div>
            <div class="cus_cell" v-if="radioType === 1">
              <i class="cus_icon icon_ein"></i>
              <div class="cell_right"><input type="text" placeholder="请输入税号" v-model="taxnum"></div>
            </div>
          </div>
        
          <div class="cus_section">
            <div class="cus_cell">
              <i class="cus_icon icon_email"></i>
              <div class="cell_right"><input type="text" placeholder="请输入接收发票的邮箱" v-model="email"></div>
            </div>
            <div class="cus_cell">
              <i class="cus_icon icon_phone"></i>
              <div class="cell_right"><input type="text" placeholder="请输入联系电话" v-model="telephone" maxlength="11"></div>
            </div>
          </div>

      </div>
      <div :class="['pay_btn', {'disabled': isLoading}]" @click="fnOpenInvoice()"><span>提交申请</span></div>
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav"
import { Toast } from 'vant'
import {DETAIL as API} from "@/assets/api"

export default {
  name: 'invoice',
  components:{
     topNav,
  },
  data() {
    return {
      title: "申请发票",
      invoiceType: 0,
      invoiceContent:'停车场收费',
      
      inlineRecords: [],
      
      paymentScenario: '',
      invoiceValue: 0,
      invoiceHead:'',
      taxnum:'',
      email:'',
      telephone:'',
      orderNum: '',
      radioType: 1, // 0 个人 1 企业
      hasOpenInvoice: false,
      isLoading: false,

      parkingPayRecordList: [],
      isHZ: 0,
    }
  },
  methods:{
    getOpenInvoiceStatus(){

      var req = {orderNum: this.orderNum}
      this.$http({
        method: 'get',
        url: API.GET_OPENINVOICE_STATUS,
        data: req,
        success: function(res){
            if (res.code == 0) {
              if(!res.flag){
                this.invoiceValue = res.pay_price
              }else{
                Toast({ message: '该订单已经开过发票了' })
                this.hasOpenInvoice = true
              }
            } else {
              Toast({ message: res.msg })
            }
        }.bind(this),
        error: function(error){
          alert("获取发票信息失败")
        }
      })
    },
    fnOpenInvoice(){
      if(this.$route.query.isYPY){
        this.openInvoiceByYPT()
      }else{
        this.openInvoiceByLZJ()
      }
    },
    openInvoiceByLZJ(){
      if(this.isLoading) return
      this.isLoading = true
      if(this.hasOpenInvoice){
        Toast({ message: '该订单已经开过发票了' })
        this.isLoading = false
      } else if( !this.validateForm() ){
        this.isLoading = false
        return false
      } else {
        var _toast = Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '正在开具发票，请稍候'
        })
        
        var req = this.inlineRecords.map(i=>{
          return {
            appid: i.appid,
            orderNum: i.orderNo,
            paymentScenario: i.paymentScenario,
            invoiceValue: i.payAmount, // 发票金额
            originalId: sessionStorage.getItem("originalId") || '',
            type: this.radioType, //抬头类型
            invoiceHead: this.invoiceHead, // 发票抬头
            taxnum: this.taxnum, //税号
            invoiceContent: this.invoiceContent, //发票内容
            email: this.email, //邮箱
            telephone: this.telephone, //电话
            invoiceType: this.invoiceType, //开票类型
          }
        })

        this.$http({
          method: 'post',
          url: API.OPEN_INVOICE,
          timeout: 10000,
          contentType: 'application/json',
          data: req,
          success: function(res){
              _toast.clear()
              if (res && res.code == 0) {
                  this.cacheData()
                  this.isLoading = false
                  Toast({
                    type: 'success',
                    message: '发票开具成功',
                    duration: 600,
                    onClose: ()=>{
                      this.$router.back()
                    }
                  })
              } else {
                Toast.fail(res.msg)
                this.isLoading = false
              }
          }.bind(this),
          error: function(error){
            alert("开具发票失败")
            this.isLoading = false
          }
        })
      }
    },
    // 获取多选开发票的订单数据
    getOpenInvoiceOrderInfo(){
      var req = {
        carNum: this.$route.query.carNum,
        commid: this.$route.query.commid,
        parkingno: this.$route.query.parkingno,
        appid: this.$route.query.appid
      }
      
      this.$http({
          method: 'post',
          url: API.GET_PARK_PAYRECORD,
          data: req,
          success: function(res){
            if(res.code == 500){
              this.Toast(res.msg)
              return
            }
            if(res.data && res.data.length > 0){
              this.parkingPayRecordList = res.data
              this.checkedList = this.parkingPayRecordList.filter(i=>{
                return this.$route.query.orders.indexOf(i.orderNum + '_' + i.paymentScenario) != -1
              })
              this.invoiceValue = this.checkedList.map(i=>i.payPrice).reduce((prev, cur)=>{
                let total = (prev*100 + cur*100)/100
                return total
              })
            }
          }.bind(this),
          error: function(error){
          }
      })
    },
    openInvoiceByYPT(){
      
      if(this.isLoading) return
      this.isLoading = true
      if( !this.validateForm() ){
        this.isLoading = false
        return false
      } else {
        var _toast = Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '正在开具发票，请稍候'
        })
        
        let _data = this.checkedList.map(i=>{
          return {
              type: this.radioType,
              paymentScenario: this.paymentScenario,
              invoiceHead: this.invoiceHead,
              invoiceValue: this.invoiceValue,//发票金额
              taxnum: this.taxnum,//税号
              email: this.email,
              telephone: this.telephone,
              invoiceType: this.invoiceType,
              orderNum: i.orderNum,
              appid: this.$route.query.appid,//此appid使用根据车牌获取可开票的停车场接口返回中的appi
              carNum: this.$route.query.carNum,
              commid: this.$route.query.commid,
              parkingno: this.$route.query.parkingno,
          }
        })
        var req = { data: _data }

        this.$http({
          method: 'post',
          url: API.OPEN_INVOICEv2,
          timeout: 10000,
          contentType: 'application/json',
          data: req,
          success: function(res){
              _toast.clear()
              if (res && res.code == 0) {
                  this.cacheData()
                  Toast({
                    type: 'success',
                    message: '发票开具成功',
                    duration: 600,
                    onClose: ()=>{
                      this.$router.back()
                    }
                  })
                  this.isLoading = false
              } else {
                Toast.fail(res.msg)
                this.isLoading = false
              }
          }.bind(this),
          error: function(error){
            Toast({message: "开具发票失败"})
            this.isLoading = false
          }
        })
      }
    },
    
    resetForm(){},
    validateForm(){
      if(!this.invoiceHead){
        Toast('请输入发票抬头')
        return false
      }
      if(this.radioType === 1){
        if(!this.taxnum || this.taxnum.length < 6){
          Toast('请输入有效发票税号')
          return false
        }
      }
      if (this.isHZ == 1) {
        if (!this.email && !this.telephone) {
          Toast('邮箱和手机号至少填写一个')
          return false
        }
        if (this.email && !this.commonUtil.validEmail(this.email)) {
          Toast('请输入有效邮箱')
          return false
        }
        if (this.telephone && !/^[0-9]+-?[0-9]+$/.test(this.telephone)) {
          Toast('请输入有效联系电话')
          return false
        }
      } else {
        if (!this.commonUtil.validEmail(this.email)) return false
        if (!/^[0-9]+-?[0-9]+$/.test(this.telephone)) {
          Toast('请输入有效联系电话')
          return false
        }
      }
      return true
    },
    toggleCheck(bool){
      this[bool] = Number(!this[bool])
    },
    restoreData(){
      if(localStorage.getItem('radioType')){
        this.radioType = Number(localStorage.getItem('radioType'))
      }
      if(localStorage.getItem('invoiceHead')){
        this.invoiceHead = localStorage.getItem('invoiceHead')
      }
      if(localStorage.getItem('email')){
        this.email = localStorage.getItem('email')
      }
      if(localStorage.getItem('telephone')){
        this.telephone = localStorage.getItem('telephone')
      }
      if(localStorage.getItem('taxnum')){
        this.taxnum = localStorage.getItem('taxnum')
      }
    },
    cacheData(){
      localStorage.setItem('radioType', this.radioType)
      localStorage.setItem('invoiceHead', this.invoiceHead)
      localStorage.setItem('email', this.email)
      localStorage.setItem('telephone', this.telephone)
      localStorage.setItem('taxnum', this.taxnum)
    },

  },
  created(){
    this.restoreData()
    this.isHZ = this.$route.query.isHZ ? this.$route.query.isHZ : 0
    // 扫码批量开票
    if(this.$route.query.hasOwnProperty('recordarray')){
      this.inlineRecords = this.$route.query.recordarray.split('__').map(i=>JSON.parse(i))
      this.invoiceValue = this.inlineRecords.map(i=>i.payAmount).reduce((prev, cur)=>(prev*100 + cur*100)/100)
    }
    // isYPY 其他开票
    if(this.$route.query.isYPY){
      this.orderNum = this.$route.query.orderNum
      let data = this.$route.query.orders.split(',')[0].split('_')
      this.paymentScenario = this.$route.query.orders ? data[data.length-1] : ''
      this.getOpenInvoiceOrderInfo()
    }
  },
  beforeDestroy(){
    
  }

}
</script>

<style lang="less" scoped>
.add_info{
  width: 100%;
  background: white;
  .cus_section{
    .cus_cell{
      width : 100%;
      position: relative;
      .cus_icon{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        width: 46px;
        height: 46px;
        &.icon_type{
          background-image: url('../../../static/images/icon_type.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 19px;
        }
        &.icon_invoice{
          background-image: url('../../../static/images/icon_invoice.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 18px 20px;
        }
        &.icon_invoicetype{
          background-image: url('../../../static/images/icon_invoicetype.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 20px;
        }
        &.icon_ein{
          background-image: url('../../../static/images/icon_ein.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 20px;
        }
        &.icon_content{
          background-image: url('../../../static/images/icon_content.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 18px;
        }
        &.icon_amount{
          background-image: url('../../../static/images/icon_amount.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 20px;
        }
        &.icon_email{
          background-image: url('../../../static/images/icon_email.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 15px;
        }
        &.icon_phone{
          background-image: url('../../../static/images/phone.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 24px 24px;
        }
      }
      .cell_right{
        box-sizing: border-box;
        border-bottom: 1px solid #f5f4f4;
        width: 100%;
        line-height: 34px;
        padding: 6px 10px 6px 50px;
        text-align: left;
        font-size: 12px;
        min-height: 46px;
        span, input{
          font-size: 12px;
          vertical-align: middle;
        }
        input{
          display: inline-block;
          width: 100%;
          height: 34px;
          padding: 0;
          margin: 0;
          border: 0;
        }
        .cus_radio_group{
          display: inline-block;
          vertical-align: middle;
          font-size: 0;
          line-height: 34px;
          .cus_radio_item{
            display: inline-block;
            vertical-align: middle;
            margin-right: 20px;
            &:last-child{
              margin-right: 0;
            }
            &.cus_checked{
              .icon_radio{
                background-image: url("../../../static/images/icon_check_round_check.png");
                background-size: 100%;
              }
            }
            .icon_radio{
              display: inline-block;
              vertical-align: middle;
              width: 16px;
              height: 16px;
              margin-right: 3px;
              background-image: url("../../../static/images/icon_check_round.png");
              background-size: 100%;
            }
          }
        }
      }

    }
  }
}
.pay_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 92%;
      height: 42px;
      line-height: 42px;
      background-color: #4687f8;
      color: white;
      margin: 36px auto 0;
      border-radius: 5px;
      font-size: 18px;
      box-shadow: 0 2px 6px #5b82c18a;
      transition: opacity .2s;
      &.disabled{
        opacity: 0.5;
      }
  }
</style>




// WEBPACK FOOTER //
// src/components/invoice/invoice.vue